module.exports = __webpack_public_path__ + "static/image/service/m/robot@3x.jpg?b54a2892";